var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.sportsBarUrl,"target":"_blank"}},[_vm._v("\n    Watch at a DIRECTV Bar\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }